<template>
    <form-dialog :value="value" @input="$emit('input', $event)" max-width="600">
        <template #activator="bindings">
            <slot v-bind="bindings"></slot>
        </template>
        <template #default="{ open }">
            <update-entity-spend-limit-card
                :value="product"
                :loading="$wait.is('updateProductSpendLimit')"
                #default="{ isValid, formId, loading, form }"
            >
                <back-button @click="open()"></back-button>
                <v-spacer></v-spacer>
                <patch-product-button
                    :value="product"
                    :patches="[{ op: 'replace', path: 'monthlySpendLimit', value: form.monthlySpendLimit }]"
                    :form="formId"
                    :clear="() => {}"
                    :valid="isValid"
                    :loading="loading"
                    v-wait-while="'updateProductSpendLimit'"
                    @http2xx="handleSuccessfulSpendLimit"
                ></patch-product-button>
            </update-entity-spend-limit-card>
        </template>
    </form-dialog>
</template>

<script>
import UpdateEntitySpendLimitCard from '@/components/Common/UpdateEntitySpendLimitCard.vue';
import PatchProductButton from '@/components/Domain.Products/PatchProductButton.vue';
import { toastSuccess } from '@/components/Common/Toast.vue';
export default {
    props: {
        value: Boolean,
        product: Object,
    },
    components: { UpdateEntitySpendLimitCard, PatchProductButton },
    methods: {
        handleSuccessfulSpendLimit(response) {
            toastSuccess(`Successfully updated spend limit to ${response.monthlySpendLimit}`);
            this.$emit('input', false);
            this.$emit('http2xx', { ...this.product, monthlySpendLimit: Number(response.monthlySpendLimit) });
        },
    },
};
</script>